export default {"id":"6a85b78e","attrs":{"viewBox":"0 0 24 24"}}